
import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator'
import AppEmbeddedAdviser from '~/components/AppEmbeddedAdviser.vue'

@Component({
  components: { AppEmbeddedAdviser },
})
export default class AppDixaChat extends Vue {
  @Prop({
    required: false,
    default: false,
    type: Boolean,
  })
  readonly openOnLoad!: boolean

  @Prop({
    required: false,
    default: false,
    type: Boolean,
  })
  readonly wide!: boolean

  isChatVisible = false
  isChatReady = false
  isAdviserVisible = false

  onReady () {
    this.isChatReady = true

    this.$dixa.on('on-widget-open-changed', (isOpen: boolean) => {
      this.isChatVisible = isOpen
    })

    this.isChatVisible = false
  }

  onBtnToggleClick () {
    this.isAdviserVisible = true
  }

  closeAdviser () {
    this.isAdviserVisible = false
    this.$nextTick(() => (this.$refs.trigger as HTMLButtonElement)?.focus())
  }

  created () {
    if (!process.client) {
      return
    }

    this.isChatReady = true

    if (!this.$dixa) {
      return
    }

    // Keep Dixa available for the camera error screen's direct support action.
    this.$dixa.init(this.$i18n.locale, {
      verticalPadding: 20,
      horizontalPadding: 16,
    })

    this.onReady()
  }

  mounted () {
    this.isAdviserVisible = this.openOnLoad
  }

  @Watch('$i18n.locale')
  onLocaleChange () {
    if (!this.$dixa) {
      return
    }

    if (!this.$dixa.isBusy) {
      this.$dixa.restart(this.$i18n.locale)
      setTimeout(this.onReady.bind(this), 100)
    }
  }

  beforeDestroy () {
    this.$dixa?.shutdown()
  }
}
